import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./realestate.css"
import { Link } from 'react-router-dom';

import Realstateimg from "../../../assets/images/Industry Page/real-estate.jpg";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Faq from "./faq-realstate";
import Swiper from "../Bfsi Solution/swiper";
import SEO from "../../seo";

export default function RealEstate() {
    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ]; 
    const CounterOnScroll = ({ end, duration = 2, className }) => {
        const { ref, inView } = useInView({
            triggerOnce: true,
            threshold: 0.3,
        });

        return (
            <span ref={ref}>
                {inView ? (
                    <CountUp end={end} duration={duration} className={className} />
                ) : (
                    <span className={className}>0</span>
                )}
            </span>
        );
    };
    return (
        <div className='product-brand'>
                <SEO
                title="Real Estate"
                description="Industries Take Advantage of Real Estate Software Development We are one of the best real estate development companies and experts in real estate software solutions as per our clients&#8217; needs. Find the best architectural knowledge to create the most innovative IT solutions focused on user experience Property Listing and Search Details: Create a user-friendly interface [&hellip;]"
                canonical="https://www.hwplindia.com/industries/real-estate/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/industries-real-estate-img.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Real Estate</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li><Link to='/industries'>Industries</Link></li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Real Estate</li>
                    </ul>
                </div>
            </section>
              <section className='bfsi'>
                <section className="ai-ml-main">
                    <div className='ai-ml-container'>
                        {/* Content Section */}
                        <div className="branding-content">
                            {/* CTA */}
                            <section className="cta-section">
                                <span className='tech'>Industries</span>
                                <h3 className='tech-h3'>Take Advantage of Real Estate Software Development</h3>
                                <p className='email'>
                                 We are one of the best real estate development companies and experts in real estate software solutions as per our clients’ needs. Find the best architectural knowledge to create the most innovative IT solutions focused on user experience
                                </p>
                            </section>

                            <section className="Industri-section">
                                <div className="industri-card">
                                    <h3 className="indu-title">Property Listing and Search</h3>
                                    <p>
                                        <strong>Details:</strong> Create a user-friendly interface for property listing, allowing users to search based on criteria like location, price range, amenities, and property type.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Enhanced property discovery, improved user experience, and streamlined search processes.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Virtual Property Tours</h3>
                                    <p>
                                        <strong>Details:</strong> Integrate virtual tour capabilities, allowing users to explore properties remotely through 3D tours, videos, or interactive walkthroughs.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Increased engagement, time-saving for both buyers and sellers, and broader accessibility.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">User Accounts and Profiles</h3>
                                    <p>
                                        <strong>Details:</strong> Enable users to create accounts, save favorite listings, track property history, and manage personal profiles.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Personalized experiences, easy communication with agents, and efficient property tracking.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">CRM for Agents</h3>
                                    <p>
                                        <strong>Details:</strong> Implement a Customer Relationship Management (CRM) system for real estate agents to manage leads, contacts, and communications.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improved agent productivity, streamlined communication, and better lead management.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Online Booking and Scheduling</h3>
                                    <p>
                                        <strong>Details:</strong> Provide a booking system for property viewings and appointments, allowing users to schedule visits online.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Convenience for buyers and sellers, improved appointment management, and increased property viewings.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Document Management and E-Signatures</h3>
                                    <p>
                                        <strong>Details:</strong> Include features for managing property documents, contracts, and facilitate electronic signatures for streamlined transactions.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Reduced paperwork, faster transaction processes, and improved document organization.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Property Valuation Tools</h3>
                                    <p>
                                        <strong>Details:</strong> Integrate tools for property valuation, allowing users to estimate the market value of a property.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Informed decision-making, better pricing strategies, and enhanced property valuation accuracy.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Map Integration and Neighborhood Insights</h3>
                                    <p>
                                        <strong>Details:</strong> Utilize map integration to display property locations and provide insights into neighborhood amenities, schools, and local services.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Comprehensive property information, improved decision-making, and enhanced property context.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Financial Calculators</h3>
                                    <p>
                                        <strong>Details:</strong> Include mortgage calculators, loan estimators, and other financial tools to help users assess affordability.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Empowered decision-making, better financial planning, and improved transparency.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Mobile Responsiveness</h3>
                                    <p>
                                        <strong>Details:</strong> Ensure the software is responsive on various devices, providing a seamless experience on smartphones and tablets.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Increased accessibility, convenience for users on the go, and improved user satisfaction.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Multi-language and Currency Support</h3>
                                    <p>
                                        <strong>Details:</strong> Provide support for multiple languages and currencies to cater to an international audience.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Expanded market reach, inclusivity, and improved user experience for global users.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">User Reviews and Ratings</h3>
                                    <p>
                                        <strong>Details:</strong> Implement a system for users to leave reviews and ratings for properties, agents, and the overall experience.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Enhanced transparency, increased trust, and improved decision-making for users.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Data Security and Compliance</h3>
                                    <p>
                                        <strong>Details:</strong> Prioritize data security by implementing encryption, secure authentication, and compliance with real estate industry regulations.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> User trust, legal compliance, and protection of sensitive information.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Reporting and Analytics</h3>
                                    <p>
                                        <strong>Details:</strong> Provide reporting tools and analytics to track user behavior, property trends, and agent performance.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Informed business decisions, performance optimization, and continuous improvement.
                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                    <section className='bfsi-clor'>
                        <section class="bfsi-section">
                            <div class="bfsi-grid">
                                <div class="bfsi-left">
                                    <h2>
                                        Meet Best Real Estate Software Development Company
                                    </h2>

                                    <p>
                                        At Horizon Webinfo Pvt. Ltd. we redefine the landscape of real estate technology. With a passion for innovation and a commitment to excellence, we deliver bespoke software solutions designed to transform the way you do business. Harnessing the power of technology, we specialize in crafting dynamic and intuitive software solutions tailored to meet the diverse needs of the real estate industry. From streamlining property management to enhancing customer experiences, our team of experienced developers is dedicated to delivering solutions that drive growth and efficiency.
                                    </p>

                                    <div class="bfsi-stats">
                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={20} duration={2} className="counter" /> +
                                            </h3>
                                            <span>Years Of Experience</span>
                                        </div>

                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={5000} duration={3} className="counter" /> +
                                            </h3>
                                            <span>Happy Customers</span>
                                        </div>

                                    </div>
                                    <span className='elementor-divider-separator'></span>
                                </div>

                                <div class="bfsi-right">
                                    <div class="red-shape"></div>
                                    <img src={Realstateimg} class="bfsi-img" />
                                </div>
                            </div>
                        </section>
                    </section>

                    <Faq />
                    <Swiper />

                </section>
            </section>
        </div>
    );
}